import { ServiceMetas } from "../Service";
import { useEffect, useState } from "react";
import useFiltroDatos from "../../../../../Hooks/useFiltroDatos";
import { ProgressBar } from "primereact/progressbar";
import SearchData from "../../../../Organism/Search";
import { ThreeCircles } from "react-loader-spinner";
import PresupuestoDetails from "../Dialogs/PresupuestoDetails";
import Reload from "../../../../Atoms/Reload";

export default function Presupuesto() {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [presupuesto, setPresupuesto] = useState();
    const [showDetalles, setShowDetalles] = useState(false);
    const { datosFiltrados, handleChangeFiltro, setDatosIniciales } =
        useFiltroDatos(data);
    useEffect(() => {
        setDatosIniciales(data);
    }, [data]);

    const getData = () => {
        setLoader(true);
        ServiceMetas.getPresupuestos((response) => {
            response.then((data) => {
                console.log(data);
                setData(data);
                setLoader(false);
            });
        });
    }

    useEffect(getData, []);

    const renderLoader = () => (
        <div className="row w100 hcenter pad15 vcenter">
            <ThreeCircles
                height="43"
                width="43"
                color="#0061FF"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor=""
                innerCircleColor=""
                middleCircleColor=""
            />
        </div>
    );

    const renderTableHeader = () => (
        <thead className="table_header encab2">
            <tr className="table_header white bold hspace vcenter fontSizeSm">
                <th className="column">Nombre</th>
                <th className="column">Monto</th>
                <th className="column">Fecha</th>
                <th className="column">Estatus</th>
                <th className="column"></th>
            </tr>
        </thead>
    );
    const renderTableBody = (datosFiltrados) => (
        <tbody className="tbodyTablaSeleccion">
            {datosFiltrados.map(renderTableRow)}
        </tbody>
    );

    const renderEmptyTable = () => (
        <tbody className="tbodyTablaSeleccion">
            <tr className="row_table">
                <td colSpan={5} className="column">
                    <div className="row w100 hcenter">Sin Presupuestos registrados</div>
                </td>
            </tr>
        </tbody>
    );

    const renderColumn = (key, content) => (
        <td className="column" key={key}>
            {content}
        </td>
    );

    const renderPregress = (key, content) => (
        <td className="column" key={key}>
            <ProgressBar
                aria-label="Status"
                style={{ color: "#2B2B2B" }}
                value={content}
            ></ProgressBar>
        </td>
    );

    const renderAction = (key, content) => (
        <td className="column hcenter vcenter text-centrado" key={key}>
            <div
                onClick={() => {
                    setPresupuesto(content);
                    setShowDetalles(true);
                }}
                style={{ cursor: "pointer", display: "flex", justifyContent: "center" }}
            >
                <i className="pi pi-eye" style={{ fontSize: "2rem" }}></i>
            </div>
        </td>
    );

    const renderTableRow = (row, index) => (
        <tr className="row_table pointier" key={index} onClick={() => { }}>
            {renderColumn("name", row.name)}
            {renderColumn("monto", row.monto)}
            {renderColumn("fecha", row.created)}
            {renderColumn("status", row.status)}
            {renderAction("progress", row)}
        </tr>
    );

    const renderTableContainer = (datosFiltrados) => (
        <div className="mxw1000px row vcenter hspace menTam">
            <div className="table-container">
                <table className="w100" cellPadding={0} cellSpacing={0}>
                    {renderTableHeader()}
                    {datosFiltrados.length > 0
                        ? renderTableBody(datosFiltrados)
                        : renderEmptyTable()}
                </table>
            </div>
        </div>
    );
    return (
        <div className="w100 row hcenter">
            <div className="mxw1000px row hcenter wrap">
                <div className="row w100 mtop15">
                    <SearchData handleChangeFiltro={handleChangeFiltro} />
                    <Reload onClick={getData} />
                </div>
                {loader ? renderLoader() : renderTableContainer(datosFiltrados)}
            </div>
            <PresupuestoDetails
                show={showDetalles}
                presupuesto={presupuesto}
                onHide={() => {
                    setShowDetalles(false);
                }}
            />
        </div>
    );
}
